var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPatronTruckingLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.717 88h8.771c24.117 0 43.852-19.8 43.852-44 0-24.201-19.734-44-43.852-44H0l10.127 17.6h84.361c14.47 0 26.311 11.881 26.311 26.4 0 14.518-11.84 26.4-26.31 26.4h-8.772V88zM20.255 35.2L30.38 52.8h20.255V88h17.54V52.8h35.082V35.2H20.254z",
    fill: "#2E5ECC"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM5IiBoZWlnaHQ9Ijg4IiB2aWV3Qm94PSIwIDAgMTM5IDg4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04NS43MTc0IDg4SDk0LjQ4ODNDMTE4LjYwNSA4OCAxMzguMzQgNjguMjAwMSAxMzguMzQgNDMuOTk5NUMxMzguMzQgMTkuNzk4OCAxMTguNjA2IDAgOTQuNDg4MyAwSDBMMTAuMTI2NyAxNy42SDk0LjQ4ODNDMTA4Ljk1OCAxNy42IDEyMC43OTkgMjkuNDgxIDEyMC43OTkgNDMuOTk5NUMxMjAuNzk5IDU4LjUxOCAxMDguOTU5IDcwLjQgOTQuNDg4MyA3MC40SDg1LjcxNzRWODhaTTIwLjI1NDUgMzUuMkwzMC4zODEyIDUyLjhINTAuNjM1NlY4OEg2OC4xNzY1VjUyLjhIMTAzLjI1OFYzNS4ySDIwLjI1NDVaIiBmaWxsPSIjMkU1RUNDIi8+Cjwvc3ZnPgo=";
export { SvgPatronTruckingLogo as ReactComponent };